import {NgModule} from '@angular/core';
import {ClauseLinkTypeToDisplayNamePipe} from './clause-link-type-to-display-name.pipe';

@NgModule({
  declarations: [ClauseLinkTypeToDisplayNamePipe],
  exports: [ClauseLinkTypeToDisplayNamePipe],
})
export class ClauseLinkTypeToDisplayNameModule {}
